import gql from 'graphql-tag';

export const HomeWidgetsMutation = gql`
	mutation HomeWidgetsMutation($id: ID!, $state: HomeWidgetState!) {
		updateUserPreferences(userPreferences: { homeWidget: { id: $id, state: $state } }) {
			homeWidgets {
				id
				state
			}
		}
	}
`;
